import { render, staticRenderFns } from "./QuizFinished.vue?vue&type=template&id=4742089e&"
import script from "./QuizFinished.vue?vue&type=script&lang=js&"
export * from "./QuizFinished.vue?vue&type=script&lang=js&"
import style0 from "./QuizFinished.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports